import { ActionButton, AltButton } from '../../common/Buttons/Buttons';
import { Input } from '../../common/Forms/Input/Input';

export const GeographicCityFormPanel = ({
  editingCityId,
  stateSelectOptions,
  register,
  errors,
  onSubmit,
  onCancel,
}) => (
  <>
    <h4 className="parameters-page__create-title">
      {editingCityId ? 'Editar ciudad' : 'Crear nueva ciudad'}
    </h4>
    <div className="parameters-page__create-fields parameters-page__create-fields--city">
      <div
        className="row"
        style={{ width: '100%', alignItems: 'flex-start' }}
      >
        <Input
          bootstrap="col-12 col-md-3"
          label={editingCityId ? 'Estado' : 'Estado *'}
          type="select"
          name="stateId"
          options={stateSelectOptions}
          register={register}
          placeholder=""
          errors={errors?.stateId?.message}
          disabled={Boolean(editingCityId)}
        />
        <Input
          bootstrap="col-12 col-md-3"
          label="Nombre de la ciudad *"
          type="text"
          name="cityName"
          register={register}
          placeholder="Nombre de la ciudad"
          errors={errors?.cityName?.message}
        />
        <div
          className="col-12 col-md-auto buttons-center-container"
          style={{ marginTop: '32px' }}
        >
          <ActionButton
            label={editingCityId ? 'Guardar cambios' : 'Guardar'}
            action={onSubmit}
          />
          <AltButton label="Cancelar" action={onCancel} />
        </div>
      </div>
    </div>
  </>
);
